import { useQuery } from '@maui/react-query'
import { maApiFetch } from '../api/apis'

export const useUserPreferencesQuery = (options = {}) => {
  return useQuery({
    queryFn: () => maApiFetch('/profile'),
    queryKey: ['userProfile'],
    refetchOnWindowFocus: false,
    select: (data) => data.preferences || {},
    ...options,
  })
}
